<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6113 0.0820312C14.0253 0.0821466 14.3611 0.418043 14.3613 0.832031V2.30469H15.2773C16.9196 2.30469 18.25 3.63671 18.25 5.27734V8.25195C18.2497 8.66594 17.914 9.00195 17.5 9.00195C17.086 9.00195 16.7503 8.66594 16.75 8.25195V7.69336H3.25V14.7217C3.25024 15.5342 3.90949 16.1934 4.72266 16.1934H11.8076C12.2216 16.1935 12.5575 16.5293 12.5576 16.9434C12.5576 17.3574 12.2217 17.6932 11.8076 17.6934H4.72266C3.08057 17.6934 1.75024 16.3621 1.75 14.7217V5.27734C1.75 3.63671 3.08042 2.30469 4.72266 2.30469H5.63867V0.832031C5.63885 0.418043 5.97467 0.0821466 6.38867 0.0820312C6.80277 0.0820312 7.13849 0.417972 7.13867 0.832031V2.30469H12.8613V0.832031C12.8615 0.417972 13.1972 0.0820312 13.6113 0.0820312ZM4.72266 3.80469C3.90934 3.80469 3.25 4.46465 3.25 5.27734V6.19336H16.75V5.27734C16.75 4.46465 16.0907 3.80469 15.2773 3.80469H4.72266Z"
            fill="currentColor"
        />
        <path
            d="M16.3887 10.6377C16.8028 10.6377 17.1386 10.9736 17.1387 11.3877V13.416H19.167C19.5811 13.4162 19.917 13.7519 19.917 14.166C19.9168 14.58 19.5809 14.9158 19.167 14.916H17.1387V16.9434C17.1386 17.3575 16.8028 17.6934 16.3887 17.6934C15.9746 17.6932 15.6387 17.3575 15.6387 16.9434V14.916H13.6113C13.1972 14.916 12.8615 14.5801 12.8613 14.166C12.8613 13.7518 13.1971 13.416 13.6113 13.416H15.6387V11.3877C15.6388 10.9737 15.9746 10.6378 16.3887 10.6377Z"
            fill="currentColor"
        />
    </svg>
</template>
